<template>
    <div id="app">
        <h1 class="title">Selecciona una pantalla</h1>
        <div class="container">
            <router-link class="opcion-pantalla" to="/pantalla/1">
                <p>Pantalla 1</p>
            </router-link>
            <router-link class="opcion-pantalla" to="/pantalla/2">
                <p>Pantalla 2</p>
            </router-link>

        </div>

    </div>
</template>
  
<script>
export default {
    name: 'SeleccionPantallas',
    components:{
    }
};
</script>
  
<style scoped>
p {
    text-align: center;
    margin: 0 !important;
}

a {
    text-decoration: none;
    color: black !important;
}

.title {
    text-align: center;
    margin: 20px 20px 0px 20px;
    font-family: 'Courier New', Courier, monospace !important;

}

.container {
    display: flex;
    justify-content: space-around;
    padding: 10px;
}



.opcion-pantalla {
    background-color: #C0FFFF;
    width: 100%;
    margin: 10px;
    border-radius: 10px;
    padding-top: 50px;
    padding-bottom: 50px;
    font-family: 'Courier New', Courier, monospace !important;
}
</style>
  